import React from "react";
import { Heart } from "lucide-react";
import { useShortlist } from "@/context/ShortlistContext";

export default function ShortlistButton({ talent, className = "", size = 18, withLabel = false }) {
  const { has, toggle } = useShortlist();
  const active = has(talent.id);
  return (
    <button
      type="button"
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggle(talent); }}
      data-testid={`shortlist-toggle-${talent.id}`}
      aria-pressed={active}
      aria-label={active ? "Verwijderen van shortlist" : "Toevoegen aan shortlist"}
      className={`inline-flex items-center gap-2 rounded-full border transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-brand-violet ${
        active ? "border-brand-violet bg-brand-violet/10 text-brand-violet" : "border-zinc-200 bg-white text-zinc-500 hover:border-zinc-400"
      } ${withLabel ? "px-4 py-2 text-sm font-semibold" : "p-2.5"} ${className}`}
    >
      <Heart size={size} className={active ? "fill-brand-violet" : ""} />
      {withLabel && (active ? "Op shortlist" : "Toevoegen aan shortlist")}
    </button>
  );
}
